<template>
    <!-- 休眠设置 -->
    <div class="mute-box">
        <!-- <div class="top-box">
            <el-button type="primary" @click='dialogVisible = true'>新增</el-button>
        </div> -->
        <div class="top-box">
            <el-form-item label="评率开关" >
                <el-switch v-model="switchShow" @change="onOffTimeUpdateClick"></el-switch>
            </el-form-item>
        </div>
        <div class="Table-Bottom">
            <el-table :header-cell-style="{ background: '#fff', color: '#000', height: '40px', }" ref="multipleTable"
                :data="tableData" :cell-style="{ 'text-align': 'center' }" tooltip-effect="dark"
                @selection-change="handleSelectionChange">
                <el-table-column prop="address" label="时间段" show-overflow-tooltip>
                    <template #default="scope">
                        <span> {{ '时间' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="开始时间" show-overflow-tooltip>
                    <template #default="scope">
                        <el-input type="text" v-model="scope.row.sleepTimeFrom"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="结束时间" show-overflow-tooltip>
                    <template #default="scope">
                        <el-input type="text" v-model="scope.row.sleepTimeTo"></el-input>
                    </template>
                </el-table-column>

            </el-table>
        </div>
        <el-button type="primary" class="bottom-but" @click="baocunclick">保存设置</el-button>

    </div>
</template>

<script>
import { deviceSleep, sleepUpdate } from '@/assets/api/zhongduan.js'

export default {
    components: {

    },
    data() {
        return {
            tableData: [
                {
                    sleepTimeFrom: '',
                    sleepTimeTo: '',
                }
            ],
            dialogVisible: false,
            value1: [],
            switchShow: true
        };
    },
    created() {
        this.deviceSleepClick()
    },
    mounted() {

    },
    methods: {
        deviceSleepClick() {
            let params = {
                imei: this.$route.query.iemi,
            }
            deviceSleep(params).then((res) => {
                console.log(res, '休眠设置');
                if ( res.data.data.deviceId ) {
                    this.tableData = [res.data.data]
                    this.switchShow = res.data.data.sleepOnOff
                }
            }).catch((err) => {
                this.$message({
                            type: 'error',
                            message: err.response.data.msg
                        });
            })
        },

        baocunclick() {
            var reDateTime = /^(?:(?:[0-2][0-3])|(?:[0-1][0-9])):[0-5][0-9]$/;
            for (let item of this.tableData) {
                if (item.sleepTimeFrom != '') {
                    if (reDateTime.test(item.sleepTimeFrom) != true) return this.$message.error('闹钟格式有误！');
                    let params = {
                        deviceId: this.tableData[0].deviceId || '',
                        sleepOnOff: this.switchShow,
                        sleepTimeFrom: this.tableData[0].sleepTimeFrom,
                        sleepTimeTo: this.tableData[0].sleepTimeTo,
                    }
                    sleepUpdate(params).then((res) => {
                        // console.log(res);
                        this.$message({
                        message: '修改成功！',
                        type: 'success'
                    });
                        this.deviceSleepClick()
                    }).catch((err) => {
                        // console.log(err);
                        this.$message({
                            type: 'error',
                            message: err.response.data.msg
                        });
                    })
                }
            }
            console.log(this.tableData, '提交');
        },
    },
};
</script>

<style scoped lang="scss">
.mute-box {
    background-color: #fff;

    .top-box {
        margin-top: 15px;
    }

    .Table-Bottom {
        width: 720px;
        /*no*/
        border: 1px solid #eee;
        margin-top: 20px;

        /deep/ {
            .el-input {
                width: 160px;
            }

            .el-table th.el-table__cell>.cell {
                text-align: center;
                font-size: 15px  ;
            }
        }
    }

    .bottom-but {
        margin: 20px 0px;
        margin-left: 130px;
    }

    .time-box {
        width: 80%;
    }

    .delete-title {
        color: red;
        cursor: pointer;
    }
}
</style>
